import { render, staticRenderFns } from "./customDelete.vue?vue&type=template&id=67ab7f6a&scoped=true&"
import script from "./customDelete.vue?vue&type=script&lang=js&"
export * from "./customDelete.vue?vue&type=script&lang=js&"
import style0 from "./customDelete.vue?vue&type=style&index=0&id=67ab7f6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ab7f6a",
  null
  
)

export default component.exports